<template>
  <div>
    <p style="font-size: 1.4rem; font-weight: 500">【臺北市政府收據雲平台個人資料使用說明】</p>
    <div>
      <p style="text-align: right">版本：11208</p>
      <p>
        臺北市政府收據雲平台(以下簡稱本系統)，為落實個人資料保護，說明以下事項，請您於使用本服務前詳閱：
      </p>
      <p>
        一、本府為提供本系統服務，蒐集個人資料之特定目的包含：175其他地方政府機關暨所屬機關構內部單位管理、公共事務監督、行政協助及相關業務、178其他財政收入、179其他財政服務。
      </p>
      <p>
        二、為提供身分識別、收據歸戶等服務，臺北市政府(以下簡稱本府)將向「臺北市政府單一識別服務(即台北通服務)」蒐集您的個人資料，包含：C001識別個人者(例如：姓名、電子郵件)、C003政府資料中之識別者(例如：身分證字號) 、C011個人描述(例如：生日)、C093財務交易(例如: 收付金額)等。
      </p>
      <p>
        三、為提供發送電子收據服務及收據內容有疑義時之連繫，本府資訊局將從本府各開立收據機關取得您的個人資料，包含：C001識別個人者(例如：姓名、手機、市話、電子郵件)。
      </p>
      <p>四、個人資料利用之期間、對象、地區及方式</p>
      <ol>
        <li>
          期間：個人資料蒐集之特定目的存續期間或本府依相關法令或契約約定執行業務所必須之保存期間。
        </li>
        <li>對象：本府所屬機關(含所屬機關(構))及本府業務委外機構。</li>
        <li>地區：本府所屬機關所在地、本府業務委外機構所在地。</li>
        <li>
          方式：開立電子收據（為提供發送電子收據服務及收據內容有疑義時之連繫）及身分識別、收據歸戶。
        </li>
      </ol>
      <p>五、當事人權利行使：</p>
      <ol>
        <li>
          依據個人資料保護法第三條規定，當事人權利行使可包含個人資料之「查詢或請求閱覽」、「請求製給複製本」、「請求補充或更正」、「請求停止蒐集、處理或利用」、「請求刪除」。
        </li>
        <li>
          為身分識別、電子收據歸戶等使用之台北通服務，當事人權利行使應依本府單一識別服務規範執行，連結如下：https://id.taipei/tpcd/或於上班時間撥打02-27208889轉8585。
        </li>
        <li>
          為提供本系統服務，當事人權利行使應向本府各收據開立機關請求，或於上班時間撥打02-27208889轉8585，由本府為您處理。
        </li>
        <li>
          本府基於稅捐稽徵機關管理營利事業會計帳簿憑證辦法第27條規定，於保存期限內，將可能依法拒絕當事人權利行使請求；收據內容有誤需更正時，應向開立機關反映，開立機關將作廢後重新開立。
        </li>
        <li>若您決定不提供您的個人資料，則有可能將無法使用本服務。</li>
      </ol>
    </div>
    <p style="font-size: 1.4rem; font-weight: 500">【臺北市政府網站個人資訊安全保護政策】</p>
    <div>
      <p style="font-weight: 500">一、隱私權保護政策</p>
      <p>
        親愛的網友，臺北市政府網站非常重視並尊重網友的隱私權。為了幫助您瞭解臺北市政府網站如何收集、應用及保護您的個人資訊，請詳細閱讀以下臺北市政府網站隱私權暨資訊安全保護政策，本政策將幫助您了解，在您使用臺北市政府網站以及其延伸服務網站所提供的服務時，我們收集、運用及保護網友個人資料的政策與原則。
      </p>
      <p>(一)適用範圍</p>
      <p>
        以下的隱私權保護政策，適用於您在臺北市政府網站以及其延伸服務網站（以www.taipei.gov.tw及look.taipei.gov.tw網域為原則，以下均簡稱為臺北市政府網站）活動時，所涉及的個人資料收集、運用與保護。但不適用於經由臺北市政府網站搜尋連結之其他網站，當您在這些網站進行活動時，關於個人資料的保護，適用各該網站的隱私權保護政策。
      </p>
      <p>(二)個人資料收集方式</p>
      <p>我們會透過以下幾種管道收集網友個人資料：</p>
      <ol>
        <li>
          線上活動及網路問卷調查：當您參加臺北市政府網站線上活動或網路問卷調查時，可能會請您提供姓名、身分證字號、電話、電子信箱及住址等個人資訊，有些活動可能會限制須加入網路市民才能參加。您也可能因為臺北市政府網站的廣告宣導頻道之超連結，而參與其他網站或機構主辦的抽獎、競賽或行銷活動，對於您主動提供的個人資訊，這些機構或連結網站各有其個別的隱私權保護政策，其資料處理措施不適用臺北市政府網站隱私權保護政策，我們無法負擔任何連帶責任。
        </li>
        <li>
          一般瀏覽：臺北市政府網站會保留網友在上網瀏覽或查詢時，伺服器自行產生的相關紀錄(LOG)，包括連線設備IP位址、使用時間、使用的瀏覽器、瀏覽及點選資料紀錄等。臺北市政府網站會對個別連線者的瀏覽器予以標示，歸納使用者瀏覽器在臺北市政府網站內部所瀏覽的網頁，除非您願意告知您的個人資料，否則臺北市政府網站不會，也無法將此項紀錄和您的個人資料進行對應。
        </li>
        <li>
          其他
          ：除了您主動於網站登錄提供個人資料外，您可能在臺北市政府網站的討論區等單元，主動提供個人資料如電子郵件，姓名等。這種形式的資料提供，不在臺北市政府網站隱私權保護政策的範圍以內。此外，如果您寫信與臺北市政府聯繫或是透過其他管道向我們反應意見，我們也會保存此項通訊及處理紀錄。
        </li>
      </ol>
      <p style="font-weight: 500">二、Cookies的運用與政策</p>
      <p>
        為提供個人化的服務，我們有時候會使用Cookies技術來儲存並在某些時候追蹤網友的資料。Cookie是從網站傳送到瀏覽器，並保存在使用者電腦硬碟中的簡短資料。網友可以在Netscape的「功能設定」的「進階」或是IE的「Internet選項」的「安全性」中選擇修改瀏覽器對Cookies的接受程度，包括接受所有Cookies、設定Cookies時得到通知、拒絕所有Cookies等。如果您選擇拒絕所有的Cookies，可能無法使用部份個人化服務或是參與部份的活動。
      </p>
      <p>一般而言，我們會依據以下目的及情況，在網友瀏覽器中寫入並讀取Cookies︰</p>
      <ol>
        <li>
          為提供更好、更個人化的服務：方便您參與個人化的互動活動。cookies
          在您註冊或登入時建立，並在您登出時修改。
        </li>
        <li>為統計瀏覽人數及分析瀏覽模式：以了解網頁瀏覽的情況，做為改善服務的參考。</li>
      </ol>
      <p style="font-weight: 500">三、個人資料的運用方式</p>
      <p>
        臺北市政府網站不會出售、出租或任意交換任何您的個人資料給其他團體或個人。
        只有在以下狀況，臺北市政府網站會在本政策原則之下，與第三者共用您的個人資料。
      </p>
      <ol>
        <li>
          線上活動及網路調查：
          臺北市政府網站所收集的受訪者姓名、身分證字號，僅供抽獎活動依據。電話、e-mail及住址等資訊，則作為通知受訪者抽獎結果及分析之用，並不做其他用途。其他資料僅止於服務分析或學術用途。除非受訪者同意，否則所有資料僅供資料分析之用，
          臺北市政府網站不會將該等資料用做其他用途。
        </li>
        <li>
          統計與分析：
          臺北市政府網站根據使用者註冊、問卷調查、行銷活動或伺服器日誌文件，對使用者的人數、興趣和行為進行內部或委託學術研究。此研究是根據全體網友的資料進行統計分析與整理，而我們所有的公開資訊或分析報告，將僅對全體使用者行為總和進行分析及公布，並不會提供特定對象個別資料之分析報告。
        </li>
      </ol>
      <p style="font-weight: 500">四、資料的分享與公開方式</p>
      <p>
        臺北市政府網站不會任意出售、交換、或出租任何您的個人資料給其他團體或個人。
        只有在以下狀況，臺北市政府網站會在本政策原則之下，與第三者共用您的個人資料。
      </p>
      <ol>
        <li>
        為了提供您其他服務或優惠權益：
        需要與提供該服務或優惠之第三者共用您的資料時，臺北市政府網站會在活動時提供充分說明，並且在資料收集之前通知您，您可以自由選擇是否接受這項特定服務或優惠。
        </li>
        <li>
        為了提供您其他服務或優惠權益：
        需要與提供該服務或優惠之第三者共用您的資料時，臺北市政府網站會在活動時提供充分說明，並且在資料收集之前通知您，您可以自由選擇是否接受這項特定服務或優惠。
        </li>
        <li>
        為進行服務品質加值、評估及研究：
        為提供網友各精確及優質之服務，臺北市政府網站得按照資料保密協議，將使用者資料與第三人資料比較對照。此外，為了向未來的合作伙伴、廣告的單位及其他第三方介紹我們的服務及其他的合法目的，臺北市政府網站得在不具名的情形之下，揭露使用者之統計資料。
        </li>
        <li>
        其他：
        本網站有義務保護其網友隱私及個人資料，非經您本人同意不會自行修改、刪除或提供任何（或部份）網友個人資料及檔案。除非經過您事先同意或符合以下情況：
        </li>
      </ol>
      <ol>
        <div>(1)中華民國司法檢調單位透過合法程序進行調閱。</div>
        <div>(2)違反網站相關規章且已造成脅迫性。</div>
        <div>(3)基於主動衍伸政府網站服務效益之考量。</div>
        <div>(4)保護其他網友之合法使用權益</div>
      </ol>
      <p style="font-weight: 500">五、資訊安全保護措施</p>
      <p>
        由於網際網路資料的傳輸不能保證百分之百的安全，儘管臺北市政府網站努力保護網友的個人資料安全，在部分情況下會使用通行標準的SSL保全系統，保障資料傳送的安全性。由於資料傳輸過程牽涉您上網環境保全之良窳，我們並無法確信或保證網友傳送或接收臺北市政府網站資料的安全，網友須注意並承擔網路資料傳輸之風險。
      </p>
      <p>
        網友基於個人意願在網站透露的各種個人資料，例如在市民論壇討論區公布個人資料如電子郵件、姓名等，可能會被他人收集和使用，如果您擔心這些困擾，您可以不用輸入這些資料。如果您在網路上公布可被他人讀取的個人資料時，可能會收到其他團體主動提供的廣告或垃圾郵件。請您諒解此部份所造成的後果均非臺北市政府網站所能控制範圍，我們也無法負擔任何責任。
      </p>
      <p style="font-weight: 500">六、隱私權暨資訊安全保護政策修訂</p>
      <p>
        臺北市政府網站會不定時修訂本項政策，以符合最新之隱私權保護規範。當我們在使用個人資料的規定做較大幅度修改時，我們會在網頁上張貼告示，通知您相關事項。
      </p>
      <p style="font-weight: 500">七、隱私權暨資訊安全保護政策諮詢</p>
      <p>
        如果您對於我們的隱私權保護政策或是有個人資料收集、運用、更新等問題，請於上班時間聯絡：02-27208889轉8585
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PrivacyInfoSecurityPolicy',
  props: {
    getUrl: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {};
  },
};
</script>
